let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bhYBS")).then(() => parcelRequire('lNdOF'));